<p-calendar #p showTime="true" [(ngModel)]="value" dataType="date" (ngModelChange)="dateChanged()" [dateFormat]="format" styleClass="w-100" appendTo="body" hourFormat="12"
            [baseZIndex]="1000000000000"></p-calendar>
